/* global BigInt */
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { Container, Table } from "react-bootstrap"
import { useAccount } from 'wagmi'
import { createPublicClient, defineChain, formatUnits, http, parseAbiItem } from 'viem'
import { publicActionsL1 } from 'viem/op-stack'
import ReactPaginate from 'react-paginate'
import Account from './Account'

// ERC20 与 ETH 存款事件签名
const ERC20_DEPOSIT_EVENT = parseAbiItem('event ERC20DepositInitiated(address indexed l1Token, address indexed l2Token, address indexed from, address to, uint256 amount, bytes extraData)');
const ETH_DEPOSIT_EVENT = parseAbiItem('event ETHDepositInitiated(address indexed from, address indexed to, uint256 amount, bytes extraData)');

const DepositAccount = () => {
    const [loader, setLoader] = useState(false)
    const tokenList = [
        {
            type: process.env.REACT_APP_L1_DAI,
            tokenSymbol: "DAI",
            decimalValue: 18
        },
        {
            type: process.env.REACT_APP_L1_USDT,
            tokenSymbol: "USDT",
            decimalValue: 6
        },
        {
            type: process.env.REACT_APP_L1_USDC,
            tokenSymbol: "USDC",
            decimalValue: 6
        },
        {
            type: process.env.REACT_APP_L1_wBTC,
            tokenSymbol: "wBTC",
            decimalValue: 8
        }
    ]

    const { address, isConnected } = useAccount()
    const [depositDetails, setDepositDetails] = useState([])

    // 创建独立的 L1 Client（用于查询历史数据，即使钱包未连接也能查询）
    const l1ClientForQuery = useMemo(() => {
        if (!process.env.REACT_APP_L1_RPC_URL) {
            return null;
        }

        const l1Chain = defineChain({
            id: Number(process.env.REACT_APP_L1_CHAIN_ID) || 11155111,
            name: 'L1',
            network: 'l1',
            nativeCurrency: {
                name: 'Ether',
                symbol: 'ETH',
                decimals: 18,
            },
            rpcUrls: {
                default: { http: [process.env.REACT_APP_L1_RPC_URL] },
                public: { http: [process.env.REACT_APP_L1_RPC_URL] },
            },
        });

        return createPublicClient({
            chain: l1Chain,
            transport: http()
        }).extend(publicActionsL1());
    }, []);

    const getDeposit = useCallback(async () => {
        if (!address || !l1ClientForQuery) {
            console.log('缺少必要参数，退出');
            return;
        }

        setLoader(false);

        try {
            const l1BridgeAddress = process.env.REACT_APP_L1_STANDARD_BRIDGE_PROXY;
            if (!l1BridgeAddress) {
                throw new Error('REACT_APP_L1_STANDARD_BRIDGE_PROXY 未配置');
            }

            const [erc20Logs, ethLogs] = await Promise.all([
                l1ClientForQuery.getLogs({
                    address: l1BridgeAddress,
                    event: ERC20_DEPOSIT_EVENT,
                    args: { from: address },
                    fromBlock: 0n,
                    toBlock: 'latest'
                }),
                l1ClientForQuery.getLogs({
                    address: l1BridgeAddress,
                    event: ETH_DEPOSIT_EVENT,
                    args: { from: address },
                    fromBlock: 0n,
                    toBlock: 'latest'
                })
            ]);

            const mapLogToRecord = async (log, overrides = {}) => {
                try {
                    const block = await l1ClientForQuery.getBlock({ blockNumber: log.blockNumber });
                    return {
                        transactionHash: log.transactionHash,
                        blockNumber: Number(log.blockNumber),
                        amount: log.args.amount,
                        l1Token: overrides.l1Token ?? log.args.l1Token,
                        l2Token: overrides.l2Token ?? log.args.l2Token,
                        from: log.args.from,
                        to: log.args.to,
                        timestamp: Number(block.timestamp),
                    };
                } catch (e) {
                    console.error(`处理区块 ${log.blockNumber} 数据失败:`, e);
                    return null;
                }
            };

            const [erc20Data, ethData] = await Promise.all([
                Promise.all(erc20Logs.map((log) => mapLogToRecord(log))),
                Promise.all(ethLogs.map((log) => mapLogToRecord(log, { l1Token: 'ETH', l2Token: null })))
            ]);

            const formattedData = [...erc20Data, ...ethData].filter(Boolean);

            // 按时间倒序排序
            const sortedData = formattedData.sort((a, b) => b.timestamp - a.timestamp);
            setDepositDetails(sortedData);
        } catch (error) {
            console.error("Fetch deposits failed:", error);
            setDepositDetails([]);
        } finally {
            setLoader(true);
        }
    }, [address, l1ClientForQuery])
    function timeConverter(timestamp) {
        var a = new Date(timestamp * 1000);
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var sec = a.getSeconds();
        var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
        return time;
    }

    /*

     */

    function retrieveEthValue(amount, givenType) {
        const tokenMeta = tokenList.find(a => a.type && givenType && a.type.toLowerCase() === givenType.toLowerCase());
        const decimals = tokenMeta?.decimalValue ?? 18;
        const amountBigInt = typeof amount === 'bigint' ? amount : BigInt(amount?._hex ?? amount ?? 0);
        return formatUnits(amountBigInt, decimals);
    }

    useEffect(() => {
        if (isConnected) {
            getDeposit()
        }
    }, [isConnected, getDeposit])
    // =============all Collections pagination start===============
    const [currentItemsCollections, setCurrentItemsCollections] = useState([]);
    const [pageCountCollections, setPageCountCollections] = useState(0);
    const [itemOffsetCollections, setItemOffsetCollections] = useState(0);
    const itemsPerPageCollections = 10;


    useEffect(() => {
        if (depositDetails) {
            const endOffsetCollections = itemOffsetCollections + itemsPerPageCollections;
            setCurrentItemsCollections(depositDetails.slice(itemOffsetCollections, endOffsetCollections));
            setPageCountCollections(Math.ceil(depositDetails.length / itemsPerPageCollections));
        } else {

        }
    }, [depositDetails, itemOffsetCollections, itemsPerPageCollections]);

    const handlePageClickCollections = (event) => {
        const newOffsetCollections =
            (event.selected * itemsPerPageCollections) % depositDetails.length;
        setItemOffsetCollections(newOffsetCollections);
    };
    // =============all Collections pagination end===============
    return (
        <>
            <div className="account_wrap">
                <Container>
                    <div className='account_inner_wrap'>
                        <Account />
                        <section className="account_withdraw_table">
                            {
                                !loader ? <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> : depositDetails?.length <= 0 ? <h4 className='text-center text-white'>No Transaction Found</h4> :
                                    <Table responsive bordered hover variant="dark">
                                        <thead>
                                            <tr>
                                                <th>Time</th>
                                                <th>Type</th>
                                                <th>Amount</th>
                                                <th>Transaction</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItemsCollections.map((element, index) => {
                                                const { timestamp, transactionHash, amount, l1Token } = element
                                                // console.log("amount", tokenList.filter(a => a.type === l1Token)[0]?.tokenSymbol);
                                                return (
                                                    <tr key={index}>
                                                        <td>{timeConverter(timestamp)}</td>
                                                        <td>Deposit</td>
                                                        <td>{retrieveEthValue(amount, l1Token)} {tokenList.filter(a => a.type === l1Token)[0]?.tokenSymbol === undefined ? "ETH" : tokenList.filter(a => a.type === l1Token)[0]?.tokenSymbol}</td>
                                                        <td> <a href={`https://sepolia.etherscan.io/tx/${transactionHash}`} target='_blank' rel='noreferrer'> {`${transactionHash.slice(0, 8)}...${transactionHash.slice(-8)}`}</a></td>
                                                        <td>Completed</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>}
                            {depositDetails?.length > 10 ? <div className='pagination_wrap'>
                                <ReactPaginate
                                    breakLabel="..."
                                    nextLabel=" >>"
                                    onPageChange={handlePageClickCollections}
                                    pageRangeDisplayed={1}
                                    marginPagesDisplayed={1}
                                    pageCount={pageCountCollections}
                                    previousLabel="<< "
                                    containerClassName="pagination justify-content-end"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    activeClassName="active"
                                />
                            </div> : ""}
                        </section>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default DepositAccount